import { render, staticRenderFns } from "./HonorCarousel.vue?vue&type=template&id=46c4a370&scoped=true"
import script from "./HonorCarousel.vue?vue&type=script&lang=js"
export * from "./HonorCarousel.vue?vue&type=script&lang=js"
import style0 from "./HonorCarousel.vue?vue&type=style&index=0&id=46c4a370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4a370",
  null
  
)

export default component.exports